import React from 'react';
import Box from '@mui/material/Box';
import { useParams } from 'react-router-dom';

import { getUserById } from 'services';
import { WhiteBox } from 'components/AppShell'
import { SimpleTabs } from 'components/Tabs'
import AssessmentAnalytics from 'components/StudentPerformance/AssessmentAnalytics';
import StudentInfo from 'components/StudentPerformance/StudentInfo';
import ScreenHeading from 'components/ScreenHeading';
import Tabs from 'components/Tabs';
import ScoreSummary from 'components/Analytics/ScoreSummary';
import StudentAnalytics from 'components/Analytics/StudentAnalytics';
import RecentAttempts from 'components/StudentPerformance/RecentAttempts';

const challenges = [
  { _id: 'assessment', label: 'Assessment' },
  { _id: 'mockInterview', label: 'Mock Interview' },
  { _id: 'interviewWizard', label: 'Interview Wizard' },
];

const ToggleOptions = [
  { _id: 'verbal', label: 'Verbal' },
  { _id: 'coding', label: 'Coding' },
];

function StudentPerformance(props) {
  const { id } = useParams();

  const [student, setStudent] = React.useState({});
  const [selectedBatch, setSelectedBatch] = React.useState('');
  const [activeTab, setActiveTab] = React.useState('interviewWizard');
  const [section, setSection] = React.useState('verbal');
  const [analyticsSection, setAnalyticsSection] = React.useState('Interview');
  const [selectedMock, setSelectedMock] = React.useState("");

  React.useEffect(() => {
    (async () => {
      const user = await getUserById(id);
      setStudent(user);
    })();
  }, [id]);

  let interviewVariantType = 'assessment';
  if (activeTab === 'mockInterview') {
    interviewVariantType = section === 'verbal' ? 'verbal_mock' : 'coding_mock';
  } else if (activeTab === 'interviewWizard') {
    interviewVariantType = section === 'verbal' ? 'verbal_iw' : 'coding_iw';
  }

  const simpleTabsOptions = challenges.map(({ _id, label }) => ({ id: _id, label }));

  const handleTabChange = (tabId) => {
    const newActiveTab = challenges[tabId]._id;
    setActiveTab(newActiveTab);
    setSection('verbal');
    setAnalyticsSection(newActiveTab === 'interviewWizard' ? 'Interview' : 'Mock');
  };

  const handleToggleChange = (toggleId) => {
    setSection(toggleId);
  };

  return (
    <Box display="flex" flexDirection="column" minHeight='calc(100vh - 76px)'>
      <ScreenHeading title="Student Performance" id="student-performance"></ScreenHeading>
      <WhiteBox sx={{display: 'flex', flexDirection: 'column', gap: 8}}>
        <StudentInfo 
          student={student} 
          setSelectedBatch={setSelectedBatch} 
          selectedBatch={selectedBatch}
          activeTab={activeTab}
        />
        <SimpleTabs
          options={simpleTabsOptions.map((opt, idx) => ({ ...opt, value: idx }))}
          value={challenges.findIndex(c => c._id === activeTab)}
          onChange={handleTabChange}
        />
        {activeTab === 'assessment' && (
          <Box display="flex" flexDirection="column" gap={6}>
            <ScoreSummary batchId={selectedBatch} interviewVariantType="assessment" studentId={id}/>
            <AssessmentAnalytics selectedBatch={selectedBatch} />
          </Box>
        )}
        {(activeTab === 'mockInterview' || activeTab === 'interviewWizard') && (
          <Box display="flex" flexDirection="column" gap={6}>
            <Tabs
              options={ToggleOptions}
              value={section}
              onChange={handleToggleChange}
              width='180px'
            />
            <ScoreSummary 
              batchId={selectedBatch} 
              interviewVariantType={interviewVariantType} 
              studentId={id}
              activeTab={activeTab}
            />
            <StudentAnalytics 
              studentId={id}
              batchId={selectedBatch}
              interviewVariantType={interviewVariantType}
              activeTab={activeTab}
              interviewType={section}
              analyticsSection={analyticsSection}
              setAnalyticsSection={setAnalyticsSection}
              selectedMock={selectedMock}
              setSelectedMock={setSelectedMock}
            />
            <RecentAttempts 
              interviewVariantType={interviewVariantType} 
              batchId={selectedBatch}
              activeTab={activeTab}
              analyticsSection={analyticsSection}
              studentId={id}
              selectedMock={selectedMock}
            />
          </Box>
        )}
      </WhiteBox>
    </Box>
  );
}

export default StudentPerformance;